class a{read(e){return new Promise((t,c)=>{try{const r=URL.createObjectURL(e);t(r)}catch(r){c(r)}})}free(e){URL.revokeObjectURL(e)}}export{a as StreamReader};
//# sourceMappingURL=StreamReader.js.map
